/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useMemo} from "react";
import TemplateStep from "../../../../../components/Wizard/Steps/TemplateStep";
import {IBaseStepProps} from "../../../../../components/Wizard/types";
import {
  useSelectErrorMessageList,
  useSelectFileUploadResponse, useSelectWarningMessageList,
  useSliceActions
} from "../../../../../../redux/ducks/Wizard/SliceProvider";
import {useDispatch} from "react-redux";
import {useMsal} from "@azure/msal-react";
import toast from "react-hot-toast";
import {usePostRequest} from "../../../../../../api/helper";
import {addCameraEndpoint, ImagerRow} from "../../../constants";
import {MaterialReactTable, MRT_ColumnDef} from "material-react-table";

import {ArgosTableSimple} from "../../../../../components/Table/ArgosTableSimple";


const ImagerStep = (props: IBaseStepProps) => {
  const {id, messagesTitle} = props
  /**
   * use error messages length for whether or not there is error for this data sheet
   */
  const dispatch = useDispatch()
  const {appendStepXErrorMessages, setWizardOpen, clearState, refreshTable} = useSliceActions()
  const errorMessages = useSelectErrorMessageList(3)
  const warningMessages = useSelectWarningMessageList(3)
  const data = useSelectFileUploadResponse()?.cosmos_data?.plotData?.imagerTable
  const cosmosData = useSelectFileUploadResponse()?.cosmos_data

  const imagerColumns = useMemo<MRT_ColumnDef<ImagerRow>[]>(
    () => [
      {
        accessorKey: 'label',
        header: 'Label',
        size: 360
      },
      {
        accessorKey: 'height',
        header: 'Vertical Pixels (Height)',
        size: 150
      },
      {
        accessorKey: 'width',
        header: 'Horizontal Pixels (Width)',
        size: 150
      },
      {
        accessorKey: 'mp',
        header: 'Resolution (MP)',
        size: 200
      },
      {
        accessorKey: 'required',
        header: 'Required',
        size: 150
      },
    ],
    []
  )

  const content2 = (
    <div style={{maxHeight: '100%'}}>
      <ArgosTableSimple 
        data={data??[]}
        columns={imagerColumns}

        initialState={{density: 'compact'}}
        enableTopToolbar={false}
        enableBottomToolbar={false}
      />
    </div>
  )

  const addSensorHandle = usePostRequest(addCameraEndpoint)
  const handleAddSensor = async () => {

    let reqBodyData: any = {
      "cosmos_data": cosmosData,
    }
    if (id != undefined) {
      reqBodyData["id"] = id
    }
    addSensorHandle(reqBodyData)
      .then((response: any) => {
        dispatch(refreshTable())
        dispatch(setWizardOpen(false))
        dispatch(clearState())
      })
      .catch((error: any) => {
        const errorMessage = error.statusText + ", please try again or contact support for assistance. Error on Sensor Camera Wizard Submission."
        toast.error(errorMessage);
        const msg = {text: errorMessage, color: '#FF0000'}
        dispatch(appendStepXErrorMessages([msg], 3))
      })
  }
  return (
    <TemplateStep
      content1={null} 
      content2={content2}
      errorMessages={errorMessages}
      warningMessages={warningMessages}
      messagesTitle={messagesTitle}
      isFirstWizardStep={false} 
      isLastWizardStep={true} 
      customTopRow={false} 
      submitPopupEnabled={true}
      handleSubmit={handleAddSensor}
      popupTitle={'Add Camera'}
      submitDialogContentText={'Would you like to add this sensor?'}
    />
  );
}

export default React.memo(ImagerStep)

